import { useNavigate, useParams } from 'react-router-dom';
import './WelcomePage.css';
import maxbonusImage from '../../assets/maxbonus.png';

const WelcomePage = () => {
    const navigate = useNavigate();
    const { sellerId, clientId } = useParams();

    const handleBonusHistoryButtonClick = () => {
        navigate(`/bonusHistory/${sellerId}/${clientId}`);
    };

    const handlePurchaseHistoryButtonClick = () => {
        navigate(`/purchaseHistory/${sellerId}/${clientId}`);
    };

    return (
        <div className="welcome-container">
            <div className="welcome-content">
                <div className="button-container">
                    <button
                        className="button history-button"
                        onClick={handleBonusHistoryButtonClick}
                    >
                        История зачисления и списания бонусов
                    </button>
                    <button
                        className="button purchase-button"
                        onClick={handlePurchaseHistoryButtonClick}
                    >
                        История покупок
                    </button>
                </div>
            </div>
            <div className="banner">
                <a
                    href="https://maxbonus.ru"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="banner-link"
                >
                    <img
                        src={maxbonusImage}
                        alt="CRM от MaxBonus"
                        className="banner-image"
                    />
                </a>
                <a
                    href="https://maxbonus.ru"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="banner-text"
                >
                    maxbonus.ru
                </a>
            </div>
        </div>
    );
};

export default WelcomePage;
